import appLocaleData from 'react-intl/locale-data/zh';
import zhMessages from '../locales/zh-Hant.json';

if (process.env.REACT_APP_CUSTOMIZE_TEXT) {
  try {
    const customizeTexts = JSON.parse(process.env.REACT_APP_CUSTOMIZE_TEXT);

    Object.keys(zhMessages).forEach(key => {
      Object.keys(customizeTexts).forEach(customizeKey => {
        if (zhMessages[key].includes(customizeKey)) {
          const rule = new RegExp(`(${customizeKey})`, 'g');
          zhMessages[key] = zhMessages[key].replace(rule, customizeTexts[customizeKey]);
        }
      });
    });
  } catch (error) {
    throw error.message;
  }
}

const ZhTWLan = {
  messages: {
    ...zhMessages,
  },
  antd: null,
  locale: 'zh-Hant',
  data: appLocaleData,
};
export default ZhTWLan;
